import { atom } from "@mdotm/shadcn/legacy/reactivity";
import type { VisibleSeries } from "$root/widgets-architecture/widgets/PortfolioPerformance/common";

/**
 * Session-scoped (not persisted) per-series visibility for the lab performance chart. Keyed by investment
 * `virtualUuid`; unknown uuids default to visible. Lives at module scope so it survives the chart ↔
 * ex-ante-metrics branch switch within a session, and resets on page reload.
 */
export const labPerformanceSeriesVisibility$ = atom<VisibleSeries>({});
